var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningOutlineIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,16.4c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.3-0.2-0.4-0.2 s-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.2,0.4C11.7,16.4,11.8,16.4,12,16.4z M11.5,13.1h1v-6h-1V13.1z M12,21 c-1.2,0-2.4-0.2-3.5-0.7c-1.1-0.5-2-1.1-2.8-1.9c-0.8-0.8-1.5-1.8-1.9-2.8C3.2,14.4,3,13.2,3,12s0.2-2.4,0.7-3.5 c0.5-1.1,1.1-2,1.9-2.9c0.8-0.8,1.8-1.4,2.8-1.9C9.6,3.2,10.8,3,12,3s2.4,0.2,3.5,0.7c1.1,0.5,2,1.1,2.9,1.9 c0.8,0.8,1.4,1.8,1.9,2.9C20.8,9.6,21,10.7,21,12s-0.2,2.4-0.7,3.5c-0.5,1.1-1.1,2-1.9,2.8c-0.8,0.8-1.8,1.5-2.9,1.9 C14.4,20.8,13.2,21,12,21z M12,20c2.2,0,4.1-0.8,5.7-2.3c1.6-1.5,2.3-3.4,2.3-5.7c0-2.2-0.8-4.1-2.3-5.7C16.1,4.8,14.2,4,12,4 C9.8,4,7.9,4.8,6.3,6.3S4,9.8,4,12c0,2.2,0.8,4.1,2.3,5.7C7.9,19.2,9.8,20,12,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlineIconWhite);
export default __webpack_public_path__ + "static/media/warning-outline-icon-white.5ee562eab087059afe211074d3f4e621.svg";
export { ForwardRef as ReactComponent };